import React from 'react'
import { useParams, Redirect } from "react-router-dom";
import FormAddEvent from './FormAddEvent';

function EditEvent() {
    const params = useParams();
    const {codigo} = params;

    return (
        <div>
            <FormAddEvent edit codigo={codigo} />
        </div>
    );
}

export default EditEvent